import { Outlet } from "react-router-dom"
import { CompanyProvider } from "./context/companyContext"

// import WrapperInactividad from "src/hooks/al-lobby/components/WrapperInactividad"

const CompanyContextLayoutRoute = () => {

    return (

        // <WrapperInactividad>
        <CompanyProvider>
            <Outlet />
        </CompanyProvider>

        // </WrapperInactividad>
    )
}

export default CompanyContextLayoutRoute;